const typesLinks = {
  ACTION: 'action',
  TEXT: 'text',
  HIGHLIGHTED: 'highlighted',
};

export default typesLinks;
